export function MapperObject(pkg) {
  const newObj: any = {
    packageName: pkg?.packageName,
    parentPackageName: pkg?.parentPackageName ?? "",
    components:
      pkg?.components?.length > 0
        ? pkg.components
            ?.map((comp: any) => {
              return {
                ...(comp.data?.customData || comp.customData || {}),
                id: comp.id,
              };
            })
            ?.filter((comp) => comp?.componentType !== "innerClass")
        : [],
    childrenPackages: [],
  };
  if (pkg?.childrenPackages && pkg.childrenPackages?.length > 0) {
    newObj.childrenPackages = pkg.childrenPackages.map((child) =>
      MapperObject(child)
    );
  }
  return newObj;
}

export function getAllComponents(pkg: any, componentId: string = null): any {
  if (!pkg) {
    return [];
  }
  
  let result: any[] = [];
  const componentsIds = new Set<string>(); // Use Set for unique IDs

  // Helper function to process components
  const processComponents = (components: any[], packageName: string) => {
    if (!components || !Array.isArray(components)) {
      return;
    }
    components.forEach((component: any) => {
      const nodeId = component.id;
      const customData = component.data?.customData || component.customData || {};
      
      if (nodeId && !componentsIds.has(nodeId)) {
        componentsIds.add(nodeId);
        result.push({
          ...customData,
          id: nodeId,
          packageName,
        });
      }
    });
  };

  // Process current package components
  if (pkg.components && Array.isArray(pkg.components) && pkg.components.length > 0) {
    processComponents(pkg.components, pkg.packageName);
  }

  // Recursively process child packages
  if (pkg.childrenPackages && Array.isArray(pkg.childrenPackages) && pkg.childrenPackages.length > 0) {
    pkg.childrenPackages.forEach((childPkg: any) => {
      if (childPkg) {
        const childResults = getAllComponents(childPkg, componentId);
        result.push(...childResults);
      }
    });
  }

  return result;
}

// Helper function to collect all packages recursively
export function getAllPackages(pkg: any): any[] {
  if (!pkg) {
    return [];
  }
  
  let result: any[] = [];
  
  // Add current package (include base package too)
  if (pkg.packageName) {
    result.push({
      pkgName: pkg.packageName,
      parentPackageName: pkg.parentPackageName || '',
    });
  }
  
  // Recursively process child packages
  if (pkg.childrenPackages && Array.isArray(pkg.childrenPackages) && pkg.childrenPackages.length > 0) {
    pkg.childrenPackages.forEach((childPkg: any) => {
      if (childPkg) {
        const childResults = getAllPackages(childPkg);
        result.push(...childResults);
      }
    });
  }
  
  return result;
}

export function replaceKey(obj, oldKeyName, newKeyName) {
  // Check if the object has the old key
  if (obj.hasOwnProperty(oldKeyName)) {
    if (oldKeyName === newKeyName) {
      return;
    }
    // Create a new property with the new key name and assign the value of the old key
    obj[newKeyName] = obj[oldKeyName];
    // Delete the old key
    delete obj[oldKeyName];
  }
  // Return the modified object
  return obj;
}

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): T {
  let timeoutId: NodeJS.Timeout;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  } as T;
}
